/**
 * Parser für `ChinaAppSysView.DefaultFilter` — Port des `<GridFilterSettings>`-Blocks aus
 * `IwmDataGridBase.razor` samt `GetOperatorEnum`.
 */

import type { FilterOperator, GridWhere } from './types';

const KNOWN_OPERATORS: readonly FilterOperator[] = [
  'contains',
  'startswith',
  'endswith',
  'equal',
  'notequal',
  'notcontains',
  'greaterthan',
  'greaterthanorequal',
  'lessthan',
  'lessthanorequal',
];

/** Pendant zu `GetOperatorEnum`: unbekannte Operatoren fallen auf `contains` zurück. */
export function parseFilterOperator(text: string): FilterOperator {
  const candidate = text.trim().toLowerCase() as FilterOperator;
  return KNOWN_OPERATORS.includes(candidate) ? candidate : 'contains';
}

/**
 * Zerlegt `"Feld equal 1 && Feld2 contains x || Feld3 equal 2"` in Filtergruppen.
 * Trennung: erst `||`, darin `&&`; je Ausdruck `Feld Operator Wert`.
 */
export function parseDefaultFilter(defaultFilter: string | null | undefined): GridWhere[] {
  if (defaultFilter === null || defaultFilter === undefined) return [];

  const wheres: GridWhere[] = [];
  for (const group of defaultFilter.split('||')) {
    for (const expression of group.split('&&')) {
      const parts = expression.trim().split(' ');
      const [field, operator, value] = parts;
      if (field === undefined || field === '' || operator === undefined || value === undefined) {
        continue;
      }
      wheres.push({ predicates: [{ field, operator: parseFilterOperator(operator), value }] });
    }
  }
  return wheres;
}
